export default __webpack_public_path__ + "static/media/article-4.bb8fabb3.webp";